import { createStaticUrl } from '../utils';
import type { ThemePackageT } from '../types';
import Background from './Background';

const Export: ThemePackageT = {
  id: 'particle-blue',
  title: 'Neural networks',
  background: Background,
  preview: {
    idle: createStaticUrl('static/themes/neural-network/nn_theme_idle.jpg'),
    hover: createStaticUrl('static/themes/neural-network/nn_theme_hover.gif'),
  },
};

export default Export;
